import { format, isToday } from "date-fns";
import ElementWrapper from "features/VehicleSidebar/VehicleList/common/ElementWrapper";
import { removeStationFromStopName } from "features/VehicleSidebar/VehicleList/utils/stopNameUtils";
import { FC } from "react";
import { To } from "react-router-dom";
import { BoxProps, DropsBadge, HStack, VStack } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import { formatDateString } from "shared/utils/dateTimeUtils";
import styled, { useTheme } from "styled-components";
/* Use as a wrapper for ShiftPlanListItem */
export const DayPlanList = styled.div`
  gap: 6px;
  min-width: 100%;
  flex: 1;
`;

const DateSpan = styled.span`
  margin-left: 9px;
  color: ${({ theme }) => theme.colorTextSecondary};
  text-transform: capitalize;
`;

type DayPlanListProps = {
  title: string;
  subTitle: string | null;
  fromLocation: string | null;
  toLocation: string | null;
  startTime: Date | string | null;
  endTime: Date | string | null;
  isSelected: boolean;
  isBus?: boolean;
  to?: To;
} & BoxProps;

export const DayPlanListItem: FC<DayPlanListProps> = ({
  title,
  subTitle,
  fromLocation,
  toLocation,
  startTime,
  endTime,
  isSelected = false,
  isBus,
  to,
}) => {
  const theme = useTheme();
  const isNotToday = startTime && !isToday(new Date(startTime));
  const NO_TIME = "--:--";

  const formatTime = (time: Date | string) =>
    time instanceof Date
      ? format(time, "HH:mm")
      : formatDateString(time, "HH:mm");

  const formattedStartTime = startTime ? formatTime(startTime) : NO_TIME;
  const formattedEndTime = endTime ? formatTime(endTime) : NO_TIME;

  const now = new Date();
  const start = startTime ? new Date(startTime) : null;
  const end = endTime ? new Date(endTime) : null;
  const isRunningNow = start && end && now >= start && now <= end;

  const dayPlanListItemContent = (
    <VStack alignItems="start" w="100%">
      <HStack justifyContent="space-between" w="100%">
        <HStack>
          <Text bold>{title}</Text>
          {subTitle && <Text secondary>{subTitle}</Text>}
        </HStack>
        {isSelected && isBus && (
          <DropsBadge semantics="success" alignItems="end">
            {isRunningNow ? "Kjører nå" : "Vises nå"}
          </DropsBadge>
        )}
      </HStack>
      <Text>
        {removeStationFromStopName(fromLocation) ?? "ukjent"}–
        {removeStationFromStopName(toLocation) ?? "ukjent"}
      </Text>

      <Text>
        {formattedStartTime}–{formattedEndTime}
        {isNotToday && (
          <DateSpan>({format(new Date(startTime), "dd.MM.yy")})</DateSpan>
        )}
      </Text>
    </VStack>
  );
  return (
    <ElementWrapper
      selected={isSelected}
      backgroundColor={theme.colorBackgroundSecondary}
      isHover
      to={to}
    >
      {dayPlanListItemContent}
    </ElementWrapper>
  );
};
